
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/good-neighbor-policy",
      function () {
        return require("private-next-pages/terms/good-neighbor-policy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/good-neighbor-policy"])
      });
    }
  